import type { HoodPriceData, ProjectPriceData } from './project-prices.models';
import type { TreeEntity } from '../../../core/models/entity.model';
import { EntityTypeKey } from '../../../shared/constants/entity-type-keys';

export const pricingPropertyKeys = {
  hood: { cost: 'CostHoodPrice', net: 'NetHoodPrice', budget: 'BudgetHoodPrice', weight: 'Weight' },
  uv: { cost: 'CostUVPrice', net: 'NetUVPrice', budget: 'BudgetUVPrice' },
  fireExtinguishing: { cost: 'CostFireExtinguishingPrice', net: 'NetFireExtinguishingPrice', budget: 'BudgetFireExtinguishingPrice' },
  project: {
    cost: 'TotalCostPrice',
    net: 'TotalNetPrice',
    budget: 'TotalBudgetPrice',
    projectLoadingMeters: 'LoadingLength',
    totalWeight: 'Weight'
  },
  numberOfModules: 'NumberOfModules',
  hoodBudgetFactor: 'HoodPriceFactor',
  uvBudgetFactor: 'UVPriceFactor',
  projectBudgetFactor: 'ProjectBudgetFactor',
  showBudgetPrice: 'ShowBudgetPrice'
};

export const buildPricingModelFromProject = (project: TreeEntity): ProjectPriceData => {
  const hoodData: HoodPriceData[] = project.Children.filter(child => child.EntityTypeKey === EntityTypeKey.GastroFlowHood).map(hood => {
    const hoodPriceData: HoodPriceData = {
      hoodName: hood.Properties['Name'].Value as string,
      hoodId: hood.Id,
      rows: [],
      includeInExports: hood.Properties['IncludeInExports'].Value as boolean
    };

    hoodPriceData.rows.push({
      productName: 'UI.ProjectPrices.HoodProduct',
      productType: 'hood',
      price: {
        budgetPrice: hood.Properties[pricingPropertyKeys.hood.budget],
        costPrice: hood.Properties[pricingPropertyKeys.hood.cost],
        factor: hood.Properties[pricingPropertyKeys.hoodBudgetFactor],
        netPrice: hood.Properties[pricingPropertyKeys.hood.net]
      },
      numberOfModules: hood.Properties[pricingPropertyKeys.numberOfModules],
      weight: hood.Properties[pricingPropertyKeys.hood.weight]
    });

    hoodPriceData.rows.push({
      productName: 'UI.ProjectPrices.UVProduct',
      productType: 'uv',
      price: {
        budgetPrice: hood.Properties[pricingPropertyKeys.uv.budget],
        costPrice: hood.Properties[pricingPropertyKeys.uv.cost],
        factor: hood.Properties[pricingPropertyKeys.uvBudgetFactor],
        netPrice: hood.Properties[pricingPropertyKeys.uv.net]
      }
    });

    // Only add FireExtinguishing rows if needed
    if (hood.Properties['FireExtinguishing'].Value !== 'None') {
      hoodPriceData.rows.push({
        productName: 'UI.ProjectPrices.FireExtinguishingProduct',
        productType: 'fireExtinguishing',
        price: {
          budgetPrice: hood.Properties[pricingPropertyKeys.fireExtinguishing.budget],
          costPrice: hood.Properties[pricingPropertyKeys.fireExtinguishing.cost],
          netPrice: hood.Properties[pricingPropertyKeys.fireExtinguishing.net]
        }
      });
    }

    return hoodPriceData;
  });

  return {
    hoods: hoodData,
    budgetFactor: project.Properties[pricingPropertyKeys.projectBudgetFactor],
    loadingMeters: project.Properties[pricingPropertyKeys.project.projectLoadingMeters],
    totalNumberOfModules: project.Properties[pricingPropertyKeys.numberOfModules],
    totalWeight: project.Properties[pricingPropertyKeys.project.totalWeight],
    total: {
      productName: '',
      productType: 'hood',
      price: {
        budgetPrice: project.Properties[pricingPropertyKeys.project.budget],
        costPrice: project.Properties[pricingPropertyKeys.project.cost],
        netPrice: project.Properties[pricingPropertyKeys.project.net]
      }
    }
  };
};
